<template>
  <div
    @click="$emit('handleScrollToBottom')"
    class="w-12 h-8 shadow-2xl drop-shadow-xl rounded-l-lg bg-scroll-to-bottom-color text-white flex items-center justify-center absolute right-0 z-[1] cursor-pointer"
  >
    <fai icon="chevron-down" />
  </div>
</template>
<script setup>
const props = defineProps({
  scrollTop: {
    type: Number,
    default: 0,
    required: true,
  },
});
</script>
